import { api_GET, api_POST_Unauthorize, api_PUT } from "./_api.js";

const requerente_api = {
    post: (model) => {
        const promise = new Promise((resolve, reject) => {
            api_POST_Unauthorize(`Requerente`, model)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    getDadosRequerente: (idRequerimento) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Requerente/getdadosrequerente/${idRequerimento ? idRequerimento : ""}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    updateDadosRequerente: (model) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`Requerente/updatedadosrequerente/`, model)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
}

export default requerente_api;
